<template>
    <md-content class="card md-layout-item md-size-100 md-small-size-100">
        <md-card class="md-form-card md-form-input md-mt-70">
            <md-card-content>
                <div class="container1 md-gutter">
                    <div class="container2 md-layout-item" :class="[{ 'md-size-100': isDaOrder }, 'md-size-60']">
                                <OrderTvForm :sale-type-id="form.grpSaleTypeId" />
                <div class="md-layout md-gutter">
                            <div class="md-layout-item">
                                <div class="md-layout-item labelContainer">
                                    <label class="md-layout-item md-caption">{{
                                            $t('views.order.product.form.label.productShare')
                                    }}</label>
                                    <span class="md-layout-item md-body-1">{{ form.productShare }} %</span>
                                </div>
                                <div class="md-layout-item slider">
                                    <slider v-model="form.productShare" v-bind="sliderOptions"
                                        :marks="{ 1: '1%', [maxProductShare / 2]: `${maxProductShare / 2}%`, [maxProductShare]: `${maxProductShare}%` }"
                                        :min="1" :max="maxProductShare" />
                                </div>


                                <template v-if="!(isDaOrder||isInternetOrder)">
                                    <div class="md-layout-item labelContainer">
                                        <label class="md-layout-item md-caption">{{
                                                $t('views.order.product.form.label.positionShare')
                                        }}</label>
                                        <span class="md-layout-item md-body-1">{{ form.positionShare }} %</span>
                                    </div>
                                    <div class="md-layout-item slider">
                                        <slider v-model="form.positionShare" v-bind="sliderOptions" />
                                    </div>
                                </template>

                        <div class="md-layout-item">
                            <label v-if="!isDaOrder" class="md-layout-item md-caption">{{ $t('views.order.product.form.label.position') }}</label>
                            <template v-if="isRadioOrder">
                            <md-checkbox v-model="form.positions" v-for="item in filteredPositions" :value="item.valueId" :key="item.name"
                                         @change="fetchPositionBlocksSurcharge(form.positions)">
                                {{ item.name }}
                            </md-checkbox>
                            </template>
                            <template v-else-if="!isDaOrder">
                            <md-checkbox v-model="form.positions" v-for="item in positions" :value="item.valueId" :key="item.name"
                                         @change="fetchPositionBlocksSurcharge(form.positions)">
                                {{ item.name }}
                            </md-checkbox>
                            </template>
                        </div>

                                <template v-if="!(isDaOrder || isInternetOrder)">
                                    <div class="md-layout-item labelContainer" v-if="!checkIfSaleTypeCennik()">
                                        <label class="md-layout-item md-caption">
                                            {{ $t('views.order.product.form.label.primeTimeShare') }}
                                        </label>
                                        <span class="md-layout-item md-body-1">{{ form.primeTimeShare }} %</span>
                                    </div>
                                    <div class="md-layout-item slider" v-if="!checkIfSaleTypeCennik()">
                                        <slider v-model="form.primeTimeShare" v-bind="sliderOptions"
                                            @change="fetchPrimetimeSurchargeDbounce" />
                                    </div>
                                </template>

                                <div class="md-layout-item">
                                    <md-checkbox v-model="beerFee" disabled>
                                        {{ $t(`views.order.product.form.label.beerFee`) }}
                                    </md-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!isDaOrder" class="md-layout-item md-size-30 surcharges">
                        <div class="md-flex-center-center">
                            <md-content class="description">
                                {{ $t('views.order.summary.table.order-information') }}
</md-content>
                        </div>
                        <div class="md-layout" :class="(isInternetOrder || isDaOrder)? 'internetSurchargesItem' : 'surchargesItem'">
                            <div class="md-layout-item md-size-60" v-if="isConfigurationCorrect()">
                                <label>Dopłaty pozycji</label>
                                <md-field>
                                    <md-input v-model="surcharges.positionShare" readonly />
                                    <md-icon md-font-set="regular-font">%</md-icon>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-60" v-if="!isConfigurationCorrect()">
                                <label>{{ $t(`views.order.product.form.label.incorrectConfiguration`) }}</label>
                            </div>
                            <div class="md-layout-item md-size-60" v-if="!(isInternetOrder || checkIfSaleTypeCennik() || (checkIfStationPolsat() && checkIfSaleTypePakiet()))">
                                <label>Dopłaty PT</label>
                                <md-field>
                                    <md-input v-model="surcharges.primeTimeShare" readonly />
                                    <md-icon md-font-set="regular-font">%</md-icon>
                                </md-field>
                            </div>
                        </div>
                    </div>
                </div>
            </md-card-content>
            <md-card-actions>
                <md-button class="md-primary" @click="$emit('cancel')">
{{ $t('views.order.product.buttons.cancel') }}
                </md-button>
                <md-button class="md-accent md-raised" @click="goToNextStep" :disabled="!isConfigurationCorrect()">
{{
                        $t('views.order.product.buttons.nextStep')
                }}
</md-button>
            </md-card-actions>
        </md-card>
    </md-content>
</template>
<script>
import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
import { dictionariesEndpoint } from '@/services/adsign-backend/endpoints';
import { orderProductsEndpoint } from '@/services/adsign-backend/endpoints';
import { OrderType } from '@/mixins/dictionariesConst';
import { debounce } from 'vue-debounce';
import { ordersEndpoint } from '../../../services/adsign-backend/endpoints';
import { debounceSettings } from "../../../config/config";
import OrderTvForm from '../OrderTvForm';

export default {
    name: "OrderProductStep2",
    mixins: [serverSideValidationErrors],
    components: { OrderTvForm },
    props: {
        currentOrder: {
            type: Object,
            default: null
        },
        orderStations: {
            type: Array,
            default: null
        },
        orderNo: {
            type: String,
            required: true
        },
        orderProducts: {
            type: Array,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        maxProductShare: {
            type: Number,
            required: true
        },
        selectedProduct: {
            type: Object,
            required: true
        },
        orderType: {
            type: String,
            required: true
        },
        saleTypeId: {
            type: Number,
            required: true,
        }
    },    
    computed: {
        filteredPositions(){
            if (this.isDaOrder) {
                return this.positions.filter(item => item.name == "1")
            }
            else {
                return this.positions.filter(item => item.name == "1" || item.name == "99")
            }
        },
        isDaOrder() {
            return this.orderType === OrderType.DA;
        },
        isInternetOrder() {
            return this.orderType === OrderType.Internet;
        },
        isRadioOrder() {
            return this.orderType === OrderType.Radio;
        },
        beerFee() {
            return this.selectedProduct?.beerTaxFee || false;
        },
        filteredOrderProducts: {
            get() {
                return this.orderProducts.filter((item) => {
                    return item.id !== this.form.duoSpotProductId &&
                        item.id !== this.form.triSpotProductId &&
                        item.id !== this.form.quadroSpotProductId &&
                        item.id !== this.form.pentaSpotProductId;
                });
            }
        }
    },
    data: function () {
        return {
            fetchPrimetimeSurchargeDebounce: debounce(val => this.fetchPrimetimeSurcharge(val), debounceSettings.defaultTime),
            sliderOptions: {
                marks: { 0: "0%", 50: "50%", 100: "100%" },
                contained: "true",
                tooltip: "none",
                processStyle: { backgroundColor: "#E51937" },
                dotStyle: { backgroundColor: "#E51937" },
                dotOptions: {
                    focusStyle: { boxShadow: "none" }
                }
            },
            sending: false,
            multiSpots: ["duoSpot", "triSpot", "quadroSpot", "pentaSpot"],
            grpSaleTypeId: 0,
            positions: [],
            form: {
                productShare: this.value.productShare,
                positionShare: this.value.positionShare || 0,
                positions: this.value.positions,
                primeTimeShare: this.value.primeTimeShare || 0,
                beerFee: this.value.beerFee
            },
            surcharges: {
                positionShare: 0,
                primeTimeShare: 0,
                duoSpot: null,
                triSpot: null,
                quadroSpot: null,
                pentaSpot: null,
            }
        };
    },
    methods: {
        goToNextStep() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$emit("input", {
                    ...this.form,
                    positions: this.form.positions || []
                    });
                this.$emit("nextStep");
            }
        },
        fetchPrimetimeSurcharge(value) {
            orderProductsEndpoint.calculateProductPrimeTimeSurcharge(this.orderNo, value)
                .then(data => {
                    this.surcharges.primeTimeShare = data.data.result;
                });
        },
        fetchPrimetimeSurchargeDbounce(value) {
            this.fetchPrimetimeSurchargeDebounce(value);
        },
        fetchPositionBlocksSurcharge(value) {
            let shortNames = this.positions.filter(p => value.includes(p.valueId)).map(p => p.shortName);
            orderProductsEndpoint.calculateProductPositionSurcharge(this.orderNo, shortNames)
                .then(data => {
                    this.surcharges.positionShare = data.data.result;
                });
        },
        isConfigurationCorrect() {
            if (this.form.positions.length > 0) {
                return this.surcharges.positionShare > 0;
            }
            else {
                return true;
            }
        },
        updateGrpSaleType(saleTypeId) {
            this.grpSaleTypeId = saleTypeId;
        },
        checkIfSaleTypePakiet() {
            return this.currentOrder.grpSaleType.valueId == 2;
        },
        checkIfSaleTypeCennik() {
            return this.currentOrder.grpSaleType.valueId == 1;
        },
        checkIfStationPolsat() {
            return this.orderStations[0].stationId == 2;
        }
    },
    mounted() {
        dictionariesEndpoint.getDictionary("position_block")
            .then(result => this.positions = result.data.sort((a, b) => parseInt(a.name) > parseInt(b.name))).then(() => this.fetchPositionBlocksSurcharge(this.form.positions));
        ordersEndpoint.getOrder(this.orderNo).then(result => this.updateGrpSaleType(result.data.grpSaleType.valueId))
        this.$watch(() => this.value, newValue => {
            this.form = {
                productShare: newValue.productShare,
                positionShare: newValue.positionShare,
                positions: newValue.positions,
                primeTimeShare: newValue.primeTimeShare,
                beerFee: newValue.beerFee
            };
        });
        this.fetchPrimetimeSurcharge(this.form.primeTimeShare);
    },
    validations: {
        form: {}
    }
    }
</script>
<style scoped lang="scss">
.description{
    font-size: 12px; 
    text-align: center; 
    margin-top: 10px; 
    padding-left: 10px; 
    padding-right: 10px
}
.slider {
    margin-top: 20px;
    margin-bottom: 20px;
}

.md-layout-item.md-caption {
    margin-right: 40px;
}

.container1 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.container2 {
    display: flex;
    flex-direction: column;
}

.surcharges {
    background-color: #F6F7F9;
    background-clip: content-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    min-width: 0;
    margin-top: 30px;
    margin-bottom: 15px;

    .surchargesItem {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        min-width: 0;
        width: 100%;
    }

    .internetSurchargesItem {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        min-width: 0;
        width: 100%;
    }

    .md-layout {
        .md-layout-item:nth-child(1) {
            margin-top: 50px;
        }

        .md-layout-item:nth-child(2) {
            margin-bottom: 20px;
        }
    }

    .md-field {
        margin-bottom: 0px;
        padding-top: 0px;
    }
}

.labelContainer {
    padding-top: 10px;
}
</style>
